import { useEffect, useState } from 'react';
import type { BrokerOfferDetails } from '../types/brokerOffer';

interface UseOfferExpiryReturn {
  secondsLeft: number;
  isExpired: boolean;
}

/**
 * Live countdown for a broker offer. Seeds from `expireSecondsLeft`, ticks down
 * every second, and reports expiry (server flag OR countdown reaching zero).
 */
export function useOfferExpiry(
  offer: BrokerOfferDetails | undefined
): UseOfferExpiryReturn {
  const [secondsLeft, setSecondsLeft] = useState(() =>
    Math.max(0, Math.floor(offer?.expireSecondsLeft ?? 0))
  );

  useEffect(() => {
    setSecondsLeft(Math.max(0, Math.floor(offer?.expireSecondsLeft ?? 0)));
  }, [offer?.expireSecondsLeft]);

  const reachedZero = secondsLeft <= 0;

  useEffect(() => {
    if (reachedZero) return;
    const intervalId = setInterval(() => {
      setSecondsLeft((prev) => Math.max(0, prev - 1));
    }, 1000);
    return () => clearInterval(intervalId);
  }, [reachedZero]);

  return {
    secondsLeft,
    isExpired: (offer?.isExpired ?? false) || reachedZero,
  };
}
